import { useId } from 'react';
import { StatusBadge } from '@pazportal/ui';
import type { ActiveTrip } from '../hooks/useActiveTrip';

/** Select among the scheduled / in-progress trips the technician can see. */
export function TripPicker({
  trips,
  selectedId,
  onSelect,
  label = 'Active field trip',
}: {
  trips: ActiveTrip[];
  selectedId: string | null | undefined;
  onSelect: (id: string) => void;
  label?: string;
}) {
  const id = useId();
  if (trips.length === 0) return null;
  const selected = selectedId ? trips.find((t) => t.id === selectedId) : undefined;

  return (
    <div>
      <label htmlFor={id} className="input-label">
        {label}
      </label>
      <select id={id} value={selectedId ?? ''} onChange={(e) => onSelect(e.target.value)} className="input-field">
        <option value="" disabled>
          Select a trip
        </option>
        {trips.map((t) => (
          <option key={t.id} value={t.id}>
            {t.project_number} — {t.customer?.name ?? 'Customer'} / {t.location?.name ?? 'Location'}
          </option>
        ))}
      </select>
      {selected && (
        <div className="mt-2">
          <StatusBadge status={selected.status ?? 'scheduled'} />
        </div>
      )}
    </div>
  );
}
